import React from 'react'
import styles from './index.module.css'

interface Props {
  label: string
}

const Button = ({ label }: Props) => {
  return (
    <div className={styles['main']}>
      <a
        href="https://sirona.service-pacemaker.com"
        target="_blank"
        rel="noreferrer"
      >
        {label}
      </a>
    </div>
  )
}

export default Button
